import React, { useEffect, useState } from 'react';

import Dialog from '../Dialog';
import useCart from '../../providers/cart';
import useHistory from '../../Router/useHistory';

const CartErrorModal = () => {
  const [show, setShow] = useState(false);
  const { cartError, reset } = useCart();
  const { listen } = useHistory();

  const onClose = () => {
    setShow(false);
    reset();
  };

  useEffect(() => {
    if (cartError) {
      setShow(true);
    }
  }, [cartError]);

  useEffect(() => {
    listen(reset);
  }, []);

  if (!show || !cartError || cartError?.type === 'TokenValidationException') {
    return null;
  }

  return (
    <Dialog toggleCloseModal={onClose} title="Något gick fel">
      {{
        modalTitle:
          cartError?.type === 'TooManyItemsInCartException'
            ? 'Oj vad du var köpsugen'
            : 'Något gick fel',
        modalBody: (
          <div>
            {cartError?.type === 'TooManyItemsInCartException'
              ? 'Nu har du lite för många varor i varukorgen, ta bort några och försök sen igen.'
              : 'Något gick fel, försök igen'}
          </div>
        ),
      }}
    </Dialog>
  );
};

export default CartErrorModal;
